// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_CriaCategoriaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /tickets/criaCategoria
 *
 * Creates a new ticket category.
 */
import { registerContract } from './validate'

export interface Tickets_CriaCategoriaInput {
NomeCategoria: string
}

registerContract('Tickets_CriaCategoriaInput', {
  NomeCategoria: { type: 'string',  required: true },
})
